import { atom } from 'jotai';

// 基础数据结构
const initialUserState = {
  userInfo: {
    name: '',
    phone: '',
    avatar: '',
  },
};

// 原始原子
export const userAtom = atom(initialUserState);

// 派生原子：方便直接操作 userInfo
export const userInfoAtom = atom(
  (get) => get(userAtom).userInfo,
  (get, set, newInfo: any) => {
    set(userAtom, { userInfo: { ...get(userAtom).userInfo, ...newInfo } });
  }
);